module.exports = __webpack_public_path__ + "static/treasure-island-fbe99cf8e76fd87ff23d0e94b1a5e07e.jpg";